import { Vue, Component, Watch } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { partnersAPI } from '@/providers/apis/partners/partners';
import PartnerRegistry from '@/components/partner-registry/partner-registry';
import PartnerProfileDetails from './partners/partner-profile-details/partner-profile-details';
import PartnerAdd from './partners/partners-add/partners-add';
@Component({
    name: 'providers',
    components: {
        'material-icons': GoogleMaterialIcon,
        'curriculum-form': PartnerAdd,
        'curriculum-provider-detail': PartnerProfileDetails,
        'curriculum-provider': PartnerRegistry,

    },
})

export default class Providers extends Vue {

    // ----------------------------------------------------------
    // Properties

    private activeComponent: any = 'curriculum-provider';

    private activePartner: any = {};

    private isDetailsMode: boolean = false;

    private categoryList: any = [];

    private isLoading: boolean = false;

    // ------------------------------------------------------------------
    // Actions

    public swithComponent(activeComp: any) {
        this.activeComponent = activeComp;
        this.isDetailsMode = false;
    }

    @Watch('$route')
    private onChangeParams() {
        // this.loadInitialComponent();
    }

    private onSelectPartner(partnerDetail: any) {
        this.isDetailsMode = true;
        this.activePartner = partnerDetail;
        this.routeToPage(partnerDetail, true); // 'curriculum-provider-detail';
    }

    private onAddPartner(partnerDetail: string) {
        this.routeToPage(partnerDetail, false);
    }

    private routeToPage(partnerDetail: string, isDetailsMode: boolean) {
        const that = this;
        that.isDetailsMode = isDetailsMode;
        that.categoryList = that.$store.state.categorySubjectStore.categoryLists;
        this.isLoading = true;
        if (this.categoryList.length > 0) {
            that.activeComponent = 'curriculum-form';
            that.activePartner = partnerDetail;
            this.isLoading = false;
        } else {
            that.$store.dispatch('categorySubjectStore/fetchCategoryList');
            setTimeout(() => {
                that.routeToPage(partnerDetail, isDetailsMode);
            }, 3000);
        }
    }

    // -----------------------------------------------------------------
    // Hooks

    private created() {
        if (this.$route.query.partnerId) {
            this.activeComponent = this.$route.query.activeComponent;
            const partnerID: any = this.$route.query.partnerId;
            partnersAPI.getPartnerById(partnerID).then((partnerDetail) => {
                this.activePartner = partnerDetail;
            });
        }
        // this.loadInitialComponent();
    }


    // ------------------------------------------------------------------------
    // methods



}
